module.exports = __webpack_public_path__ + "media/images/front/about/dba_logo-1f90e2b8ea4d92c868e6e62b9ffc8e22.png";